export default __webpack_public_path__ + "static/media/cover3.049396ed.png";